const getDefaultState = () => {
  return {
    sidebarSection: 'holdings',
    sidebarMode: null
  }
}

const state = getDefaultState()

const actions = {
  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  setSidebarSection (state, selection) {
    state.sidebarSection = selection
    this.commit('accounts/filterList', selection)
  },
  setSidebarMode (state, data) {
    state.sidebarMode = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
